import { useEffect, useState } from 'react';
import {
  Paper, Table, TableHead, TableRow, TableCell, TableBody, TextField, MenuItem,
  Stack, Button, Chip, Typography, Pagination, Box,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import InventoryIcon from '@mui/icons-material/Inventory';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FolderIcon from '@mui/icons-material/Folder';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import api from '../services/api';

const PAGE_SIZE = 10;

export default function VendorTenders() {
  const navigate = useNavigate();
  const [tenders, setTenders] = useState([]);
  const [mdas, setMdas] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({ mda: '', category: '', search: '' });
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const load = async (toPage = page) => {
    const params = { page: toPage, pageSize: PAGE_SIZE };
    if (filters.mda) params.mda = filters.mda;
    if (filters.category) params.category = filters.category;
    if (filters.search) params.search = filters.search;
    // TEMP (historical data entry): showing closed tenders so vendors can bid on past records — restore '/public/tenders/open' to revert
    // const { data } = await api.get('/public/tenders/open', { params });
    const { data } = await api.get('/public/tenders/closed', { params });
    setTenders(data.data.items || []);
    setTotal(data.data.total || 0);
  };

  useEffect(() => {
    (async () => {
      const [m, c] = await Promise.all([api.get('/meta/mdas'), api.get('/meta/categories')]);
      setMdas(m.data.data); setCategories(c.data.data);
    })();
    load(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nav = [
    { label: 'Dashboard', path: '/vendor', icon: <DashboardIcon /> },
    { label: 'Open Tenders', path: '/vendor/tenders', icon: <DescriptionIcon /> },
    { label: 'My Bids', path: '/vendor/bids', icon: <InventoryIcon /> },
    { label: 'Clarifications', icon: <QuestionAnswerIcon />, disabled: true },
    { label: 'Award Results', icon: <EmojiEventsIcon />, disabled: true },
    { label: 'Profile & Documents', path: '/vendor/profile', icon: <FolderIcon /> },
  ];

  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return (
    <DashboardLayout nav={nav} title="Open Tenders">
      <Paper sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          <TextField select label="MDA" value={filters.mda} onChange={(e) => setFilters({ ...filters, mda: e.target.value })} sx={{ minWidth: 180 }}>
            <MenuItem value="">All</MenuItem>
            {mdas.map((m) => <MenuItem key={m.id} value={m.name}>{m.name}</MenuItem>)}
          </TextField>
          <TextField select label="Category" value={filters.category} onChange={(e) => setFilters({ ...filters, category: e.target.value })} sx={{ minWidth: 180 }}>
            <MenuItem value="">All</MenuItem>
            {categories.map((c) => <MenuItem key={c} value={c}>{c}</MenuItem>)}
          </TextField>
          <TextField label="Search" value={filters.search} onChange={(e) => setFilters({ ...filters, search: e.target.value })} fullWidth />
          <Button variant="contained" onClick={() => { setPage(1); load(1); }}>Apply</Button>
        </Stack>
      </Paper>

      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Tender Title</TableCell><TableCell>MDA</TableCell><TableCell>Category</TableCell>
              <TableCell>Deadline</TableCell><TableCell>Status</TableCell><TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tenders.map((t) => (
              <TableRow key={t.id} hover>
                <TableCell>{t.title}</TableCell>
                <TableCell>{t.mda?.name}</TableCell>
                <TableCell><Chip size="small" label={t.category} /></TableCell>
                <TableCell>{t.submissionDeadline ? new Date(t.submissionDeadline).toLocaleDateString('en-GB') : 'â€”'}</TableCell>
                <TableCell><Chip size="small" color="success" label={t.status} /></TableCell>
                <TableCell align="right"><Button size="small" onClick={() => navigate(`/portal/tenders/${t.id}`)}>View Details</Button></TableCell>
              </TableRow>
            ))}
            {tenders.length === 0 && (
              <TableRow><TableCell colSpan={6}><Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>No open tenders match your filters.</Typography></TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <Pagination count={pageCount} page={page} onChange={(_, p) => { setPage(p); load(p); }} color="primary" />
      </Box>
    </DashboardLayout>
  );
}


